import React, {useContext, useEffect, useState} from 'react'
import { useTheme } from '@mui/material/styles';
import FechaFunction from '../../function/FechaFunction';
import { InputReadQuill } from '../index';
import ComentarioTicketService from '../../services/comentarioTicket.service';
import { SocketContext } from '../../context/SocketContext';
import { Avatar, Box, Card, Grid, Typography } from '@mui/material';
import CommentAttachedFileCard from './CommentAttachedFileCard';

const ComentarioTicketCard = ({
    item,
    user,
    estado,
    onGuardar,
    autorizado,
    cvv
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    /* eslint no-nested-ternary: "error" */
    const token = localStorage.getItem('token');
    const tokenNubi = localStorage.getItem('tokenNubi');
    const tokenStr = localStorage.getItem('tokenStr');
    const { sockets } = useContext( SocketContext );
    const esCreador = item?.createdPersonaId_com === user?.id_p;
    const comPrivado = item?.isVisible_com;
    const [autorizar, setAutorizar] = useState(false);
    const [tokenCvv, setTokenCvv] = useState(null);
    const urlNubi = 'https://zeta.strongsystems.com.ar:8000/api/img?url=comentarios/'
    const urlCvv = 'https://911.nubicom.com.ar:8000/api/img?url=comentarios/'

    useEffect(() => {
        const hoy = new Date();
        const hoyStr = FechaFunction.format(hoy)
        const coment = FechaFunction.format(new Date(item.createdAt))
        if(coment === hoyStr && !item?.isVisible_com && !estado && autorizado && cvv){
            setAutorizar(true)
        }else{
            setAutorizar(false)
        }
    }, [autorizado])

    const getCardBackground = () => {
        if (esCreador) {
            return isDarkMode ? '#e7e7e9 !important' : '#e7e7e9 !important';
        }
        return isDarkMode ? '#e6f0ff !important' : '#e6f0ff !important';
    };

    return (
        <Grid container key={item.id_com} id={item.id_com} mb={4}>
            {!esCreador &&(
                <Grid item xs={1} md={0.5}>
                    <Avatar src={item?.autor?.foto_p} sx={{width:30,height:30,boxShadow:3}} />
                </Grid>
            )}
            <Grid item xs={11}>
                <Card
                    sx={{
                        background: getCardBackground(),
                        borderBottomLeftRadius:16,
                        borderBottomRightRadius:16,
                        borderTopLeftRadius: esCreador ? 16 : 1,
                        borderTopRightRadius: esCreador ? 1 : 16,
                        p: 1
                    }}
                >
                        <Typography
                            sx={{
                                color: isDarkMode ? '#000' : '#000',
                                fontWeight: 'bold',textAlign:'right'
                            }}
                            component='div'
                        >
                            {item?.autor?.nombre_p} -
                            <Box fontWeight='normal' display='inline'>
                                {item?.autor?.departamento_p || ''}
                            </Box>
                        </Typography>
                    <Box>
                        <InputReadQuill
                            id="cuerpo_tk"
                            template={item.cuerpo_com}
                        />
                    </Box>
                </Card>
                <CommentAttachedFileCard 
                    attachments={item?.img}
                    baseUrl={cvv ? urlCvv : urlNubi}
                    cvv={cvv}
                    user={user}
                />
                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',textAlign: !esCreador ? 'right' : 'left',marginTop:1}} variant='body2'>
                    {item && !item?.isVisible_com && cvv &&('Comentario Oculto - ')}
                    {`${FechaFunction.format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm:ss')}`}
                </Typography>
            </Grid>
            {esCreador &&(
                <Grid item xs={1}>
                    <Avatar src={item?.autor?.foto_p} sx={{width:30,height:30,boxShadow:3,marginLeft:0.5}} />
                </Grid>
            )}
        </Grid>
    )
}

ComentarioTicketCard.defaultProps = {
    canShowMore: false,
    buttons: null,
};

export default ComentarioTicketCard;
